import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(
    () => import(/* webpackChunkName: "OfflineSessionData" */ './lazyIndex'),
    { name: 'OfflineSessionData' }
);

export const lazyApplyTombstonesToSessionData: LazyAction<
    typeof lazyIndex.applyTombstonesToSessionData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.applyTombstonesToSessionData);
export const lazyGetOfflineSessionData: LazyAction<
    typeof lazyIndex.getOfflineSessionData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getOfflineSessionData);
export const lazySaveOfflineSessionData: LazyAction<
    typeof lazyIndex.saveOfflineSessionData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.saveOfflineSessionData);
